/**
 * Clave de un metadato
 */
export default class IdMetadato {
  /** @type {Number?} */ idFacturae = null
  /** @type {Number?} */ idInvoice = null
  /** @type {String?} */ Campo = null
}
